import { Checkbox, FormControl, Input } from '@visualfabriq/vf-ui-kit';

import * as DataStagingStep from 'src/dto/PipelineStep/DataStagingStep';

type ToIntMethodProps = {
  fields: DataStagingStep.ToInt;
  onUpdate: (fields: DataStagingStep.ToInt) => void;
};

export function ToIntMethod(props: ToIntMethodProps) {
  const { fields, onUpdate } = props;

  return (
    <>
      <FormControl label="Default Value" disabled={false} required>
        <Input
          type="number"
          value={fields.default as unknown as number}
          onChange={(event) =>
            onUpdate({
              ...fields,
              default: Number.parseInt(event.target.value),
            })
          }
        />
      </FormControl>

      <Checkbox
        checked={fields.force_type}
        onChange={(event) => {
          onUpdate({
            ...fields,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            force_type: !!(event.target as any).checked,
          });
        }}
      >
        Set default in case of invalid value
      </Checkbox>
    </>
  );
}
